import React from 'react'
import smiling from "../../Assets/Images/Vectors/smiling_face.png";
import userWithLaptop from "../../Assets/Images/Vectors/laptop_user.png";
import idea from "../../Assets/Images/Vectors/idea.png";
import serviceImg_3 from "../../Assets/Images/Vectors/idea.png";
import magnet_1 from "../../Assets/Images/Vectors/magnet.png";
import magnet_2 from "../../Assets/Images/Vectors/social_magnet.png";
import gears from "../../Assets/Images/Vectors/gears.png";
import networking from "../../Assets/Images/Vectors/networking.png";


import TagFacesOutlinedIcon from '@mui/icons-material/TagFacesOutlined';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import { Link } from 'react-router-dom';

function Services() {
    return (
        <section className="service" id="service">
            <div className="container center w-100 column">
                <p className="section-subtitle">OUR FEATURES</p>

                <h2 className="h2 service-title section-title w-75 ">Heres how <strong>DEEPBLUE</strong> can benefit your business/startup</h2>
                <p className='service-detail-text w-50 text-align-left'>Build more meaningful and lasting relationships - better understand their needs, indentify new opportunities to help address any problem faster.</p>
                <ul className="service-list">
                    {/* Feature one */}
                    <li>
                        <div className="service-card">
                            <div className="card-icon">

                                <img
                                    width={"50px"}
                                    src={smiling}
                                    alt="Service 1"
                                />
                            </div>
                            <h3 className="h3 card-title">
                                Customer Satisfaction
                            </h3>
                            <p className="card-text">
                                With <strong>DEEPBLUE</strong>, you can provide personalized support when and where customers need it, so customers stay happy.
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>

                        </div>
                    </li>
                    {/* Feature two */}
                    <li>
                        <div className="service-card">
                            <div className="card-icon">
                                <img
                                    height={"50px"}
                                    src={userWithLaptop}
                                    alt="Service 2"
                                />
                            </div>

                            <h3 className="h3 card-title">
                                Support your Support
                            </h3>

                            <p className="card-text">
                                Productive agents are happy agents. Give them all the support tools and information they need to best serve the customers.
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>
                        </div>
                    </li>
                    {/* Feature three */}
                    <li>
                        <div className="service-card">
                            <div className="card-icon">
                                <img
                                    width={"50px"}
                                    src={idea}
                                    alt="Service 3"
                                />
                            </div>

                            <h3 className="h3 card-title">
                                Grow Without Growing Pains
                            </h3>

                            <p className="card-text">
                                Our software is powerful enough handle the most complex business, yet flexible enough to scale with you as you grow.
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>
                        </div>
                    </li>
                    {/* Feature four */}
                    <li>
                        <div className="service-card">
                            <div className="card-icon">
                                <img
                                    width={"50px"}
                                    src={gears}
                                    alt="Service 3"
                                />
                            </div>

                            <h3 className="h3 card-title">
                                Operations
                            </h3>

                            <p className="card-text">
                                Powerfull tool that lets you easily sync, clean and create customer data.
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>
                        </div>
                    </li>
                    {/* Feature five */}
                    <li>
                        <div className="service-card">
                            <div className="card-icon">
                                <img
                                    width={"50px"}
                                    src={magnet_2}
                                    alt="Service 3"
                                />
                            </div>

                            <h3 className="h3 card-title">
                                Marketing
                            </h3>

                            <p className="card-text">
                                <strong>DEEPBLUE</strong> makes you worry less with customer affinity, get the right audience, and convert more visitors into loyal customers
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>
                        </div>
                    </li>

                    <li>
                        <div className="service-card">
                            <div className="card-icon">
                                <img
                                    width={"50px"}
                                    src={networking}
                                    alt="Service 3"
                                />
                            </div>

                            <h3 className="h3 card-title">
                                Services
                            </h3>

                            <p className="card-text">
                                Customer service software that helps you deepen customer relationships.
                            </p>
                            <Link to="/property-listing" className="card-link">
                                <span>Learn More</span>
                                <ArrowRightAltOutlinedIcon />
                            </Link>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Services